import { IUrlSetConfiguration } from './UrlSerConfiguration';

export enum UrlSetState {
	NEW = 'NEW',
	PENDING = 'PENDING',
	RUNNING = 'RUNNING',
	DONE = 'DONE',
	CANCELING = 'CANCELING',
	STOPPING = 'STOPPING',
	STOPPED = 'STOPPED',
	CANCELED = 'CANCELED',
	FAILED = 'FAILED'
}

export interface IUrlSet {
	id?: string;
	createdTime?: string;
	state?: UrlSetState;
	urls?: string[];
	updatedTime?: string;
	configuration?: IUrlSetConfiguration;
	totalUrlsCount?: number;
}
